import React from "react";
import { makeStyles, Theme, createStyles, Typography, Button, Box } from '@material-ui/core';
import CustomDialog from "./CustomDialog";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogRoot: {
            zIndex: 99999,
        },
        title: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(24),
            fontWeight: 'bold',
            marginBottom: theme.spacing(2),
            textAlign: 'center',
        },
        message: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(16),
            lineHeight: 1.5,
            marginBottom: theme.spacing(3),
            textAlign: 'center',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: theme.spacing(2),
        },
        button: {
            minWidth: '120px',
        },
    })
);

interface GeneralInfoPopupProps {
  open: boolean,
  onClose: () => void,
  titleText: string,
  messageText: string,
  confirmText: string
}

const GeneralInfoPopup: React.FC<GeneralInfoPopupProps> = ({
  open,
  onClose,
  titleText,
  messageText,
  confirmText
}) => {
  const classes = useStyles();

  return (
    <CustomDialog
      open={open}
      handleClose={onClose}
      header=""
      maxWidth="sm"
      style={{
        zIndex: 99999
      }}
      PaperProps={{
        style: {
          zIndex: 99999,
          position: 'relative'
        }
      }}
    >
      <Box>
        <Typography className={classes.title}>
          {titleText}
        </Typography>
        <Typography className={classes.message}>
          {messageText}
        </Typography>
        <Box className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            className={classes.button}
          >
            {confirmText}
          </Button>
        </Box>
      </Box>
    </CustomDialog>
  );
};

export default GeneralInfoPopup;